import { FaShieldAlt, FaHandsHelping, FaFire } from "react-icons/fa";

const whyChooseUs = {
    sub: "Our Mission",
    heading: "Safeguarding Lives, Ensuring Community Safety.",
    content: "At BlazeGuard Fire Department, our mission is to safeguard lives and ensure community safety through prompt and efficient emergency response services.",
    points: [
        {
            id: 1,
            icon: <FaShieldAlt />,
            title: 'Emergency Readiness',
            content: "We are committed to maintaining the highest level of emergency readiness, ensuring a swift and effective response to any crisis.",
        },
        {
            id: 2,
            icon: <FaHandsHelping />,
            title: 'Community Safety',
            content: "We actively promote community safety through educational programs, outreach initiatives, and fostering a culture of fire prevention.",
        },
        {
            id: 3,
            icon: <FaFire />,
            title: 'Fire Prevention Awareness',
            content: "Through workshops, drills, and public awareness campaigns, we educate the community on fire risks and safety measures to prevent emergencies before they happen.",
        },
    ]
};

export default whyChooseUs;